export const saveEvent = "SAVE_EVENT";
export const saveSessions = "SAVE_SESSIONS";
export const clearEvent = "CLEAR_EVENT";
export const saveSettings = "SAVE_SETTINGS";

export const getEventBegin = "GET_EVENT_BEGIN";
export const getEventSuccess = "GET_EVENT_SUCCESS";
export const getEventFailure = "GET_EVENT_FAILURE";
